// extracted by mini-css-extract-plugin
export default {"content":"Description_content__B-gtz"};